import { useFormatter } from "next-intl";

export const currencyFormatter = (
  price: number,
  currency: string,
  format: ReturnType<typeof useFormatter>,
  isDividedBy100: boolean = true,
  ifIntformat: boolean = false,
) => {
  if (ifIntformat) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency,
      maximumFractionDigits: 0,
      trailingZeroDisplay: "stripIfInteger",
    })
      .format(Math.round(Number(price) / (isDividedBy100 ? 100 : 1) || 0))
      ?.replace(/\b(CN|US|UK)\b/g, "")
      ?.replace(/(\d)\s+(\d)/g, "$1,$2")
      ?.replace(/\s+(?=\d)/g, "");
  }

  return format
    .number(Math.round(Number(price) / (isDividedBy100 ? 100 : 1) || 0), {
      style: "currency",
      currency: currency,
      trailingZeroDisplay: "stripIfInteger",
    })
    ?.replace(/(\p{Sc})\s+(\d)/u, "$1$2")
    .replace(/CN|US|UK/g, "")
    ?.replace(/\s+(?=\d)/g, "");
};
